<mat-nav-list *ngIf="reportCurrentUser">
    <mat-list-item>
        <mat-icon mat-list-icon>person</mat-icon>          
        <span matLine class="content">            
            <span class="admin-role">{{ reportCurrentUser.user_type__name }}</span>
            <span class="admin-email">{{ reportCurrentUser.email }} </span> 
        </span>
    </mat-list-item>
</mat-nav-list>
 